import { SetEntry } from "../../../SetInventory/SetInventory";
import { ActionEntry } from "../../ActionEntries";

/**
 * Sets the visibility of sets when their corresponding BuySet actions become visible
 * Called alongside ApplyActionVisibility to keep sets and actions in sync
 */
export const ApplySetVisibility = (
  action: ActionEntry,
  newActions: Map<string, ActionEntry>,
  newSets: Map<string, SetEntry>,
) => {
  for (let i = 0; i < action.actionVisibility.length; i++) {
    const actionId = action.actionVisibility[i].actionId;
    const changableAction = newActions.get(actionId);

    // If this is a BuySet action that just became visible, make the corresponding set visible too
    if (
      changableAction &&
      changableAction.type === "BuySet" &&
      changableAction.visible
    ) {
      // Extract set ID from action ID (e.g., "buy_set_6772-1" -> "6772-1")
      const setId = actionId.replace("buy_set_", "");
      const set = newSets.get(setId);

      if (set && !set.visible) {
        set.visible = true;
      }
    }
  }

  return newSets;
};
